module.exports = __webpack_public_path__ + "img/669-8b903f.png";